import React, { useContext } from 'react';

export type MealCategoryFormType = {
  //add types here
};

type NewMealCategoryContextType = {
  formData: MealCategoryFormType;
  setFormData: (item: MealCategoryFormType) => void;
};

export const NewMealCategoryContext = React.createContext({} as NewMealCategoryContextType);

const useNewMealCategoryContext = () => {
  const context = useContext(NewMealCategoryContext);
  return context;
};

export default useNewMealCategoryContext;
